// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab[data-v-7029e5d0]:not(.v-tab--active){color:#000!important}", ""]);
// Exports
module.exports = exports;
